import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../app/Application';
import { showLogin, showMoreMenu } from '../../../app/initApp';
import { showFAQPopup } from '../../../app/usecases/showFAQPopup';
import Button from './Button';

// Styles
import styles from './Header.module.css';

interface Props {
  isLoggedIn: boolean;
  mainLogoUrl: string;
}

const Header = (props: Props) => {
  const isLoggedIn = props.isLoggedIn;

  function onButtonClick() {
    if (isLoggedIn) {
      showMoreMenu();
    } else {
      showLogin();
    }
  }

  function onFAQClick() {
    showFAQPopup();
  }

  return (
    <div className={styles.whiteHeaderWrapper + ' partner-border-color1'}>
      <div className={styles.whiteHeader}>
        <div className={styles.logoContainer}>
          <img src={props.mainLogoUrl} height="50" alt="" />
        </div>
        <div className={styles.wrapper}>
          <Button
            className={styles.userButton + ' partner-color3'}
            label='FAQ'
            onClick={onFAQClick} />
          <div className={styles.divider + ' partner-color3'}>|</div>
          <div className={styles.spacer} />
          <Button
            className={styles.userButton + ' partner-color3'}
            iconCls={isLoggedIn ? 'fas fa-user-check' : 'fas fa-sign-in-alt'}
            label={isLoggedIn ? 'My Account' : 'Sign In / Create Account'}
            onClick={onButtonClick} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    isLoggedIn: state.Session.coachesKey ? true : false,
    mainLogoUrl: state.GUI.partnerLogoUrl
  }
};

export default connect(mapStateToProps, null)(Header);
